import { render, staticRenderFns } from "./PcSideBar.vue?vue&type=template&id=3b0e8b20&scoped=true&"
import script from "./PcSideBar.vue?vue&type=script&lang=ts&"
export * from "./PcSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e8b20",
  null
  
)

export default component.exports